"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildZoomedActivityUrl = exports.getZoomFactor = void 0;
const getZoomFactor = () => Math.round((window.outerWidth / window.innerWidth) * 100) / 100;
exports.getZoomFactor = getZoomFactor;
const buildZoomedActivityUrl = (url) => url + `&zoom=${exports.getZoomFactor()}`;
exports.buildZoomedActivityUrl = buildZoomedActivityUrl;
